import Joi from 'joi';
import { ProductType } from 'constants.js';

const details = {
  name: Joi.string()
    .label('Condition Query Name')
    .min(3)
    .max(100)
    .required(),
  productName: Joi.string()
    .label('Product Type')
    .required(),
  subscriberListId: Joi.when('productType', {
    is: ProductType.List,
    then: Joi.string()
      .label('Subscribers List')
      .required()
  }),
  schemaIdentifier: Joi.string()
    .label('Event Type')
    .required()
};

const design = {
  conditionExpression: Joi.object({
    valid: Joi.bool().valid(true),
    subConditionExpressions: Joi.array().min(1)
  })
};

export default {
  details,
  design,
  all: {
    ...design,
    ...details
  }
};